export const getPrintTemplate = (values) => {
  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");
  const num = (v) => Number(v) || 0;

  const getTotals = (rows) => {
    const t = { creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 };
    (rows || []).forEach(r => {
      const sub = (r.creditValues || []).reduce((a, b) => a + num(b), 0);
      const otherTotal = (r.otherVoucherValues || []).reduce((a, b) => a + num(b), 0);
      t.creditValues.forEach((_, i) => t.creditValues[i] += num(r.creditValues[i]));
      t.otherVoucherValues.forEach((_, i) => t.otherVoucherValues[i] += num(r.otherVoucherValues[i]));
      t.subTotalCredit += sub;
      t.totalCost += (sub + otherTotal);
    });
    return t;
  };

  const tA = getTotals(values.part1.rowsA);
  const tB = getTotals(values.part1.rowsB);
  const tAB = {
    creditValues: tA.creditValues.map((v, i) => v + tB.creditValues[i]),
    subTotalCredit: tA.subTotalCredit + tB.subTotalCredit,
    otherVoucherValues: tA.otherVoucherValues.map((v, i) => v + tB.otherVoucherValues[i]),
    totalCost: tA.totalCost + tB.totalCost
  };

  const part1Html = `
    <div class="section-title">NHẬT KÝ CHỨNG TỪ SỐ 7</div>
    <div class="section-subtitle">Phần I: Tập hợp chi phí sản xuất, kinh doanh toàn doanh nghiệp</div>
    <div style="text-align: center; font-style: italic; font-size: 9px; margin-bottom: 5px;">Ghi Có các TK: 152, 153, 154, 214, 241, 242, 334, 335, 338, 352, 356, 621, 622, 623, 627</div>
    <div style="text-align: center; font-weight: bold; margin-bottom: 10px;">Tháng ${values.month} năm ${values.year}</div>

    <table class="print-table" style="width: 100%;">
        <thead>
            <tr>
                <th colspan="2" style="height: 60px; position: relative;" class="diagonal-header">
                    <div style="position: absolute; top: 5px; right: 5px;">Các TK Ghi có</div>
                    <div style="position: absolute; bottom: 5px; left: 5px; text-align: left;">Số TT / Các TK ghi Nợ</div>
                </th>
                <th colspan="18">Các TK Ghi có</th>
                <th colspan="4">Các TK phản ánh ở các NKCT khác</th>
                <th rowspan="3" width="80">Tổng cộng chi phí</th>
            </tr>
            <tr>
                <th rowspan="2" width="30">Số TT</th>
                <th rowspan="2" width="80">Các TK ghi Nợ</th>
                ${values.part1.creditAccountLabels.map(l => `<th>${l || ""}</th>`).join("")}
                <th rowspan="2">Cộng</th>
                <th colspan="4">NKCT số</th>
            </tr>
            <tr>
                ${values.part1.creditAccountLabels.map((_, i) => `<th>${i + 1}</th>`).join("")}
                ${values.part1.otherVoucherLabels.map(l => `<th>${l || ""}</th>`).join("")}
            </tr>
            <tr class="bg-light-grey">
                <th>A</th><th>B</th>
                ${Array.from({ length: 17 }).map((_, i) => `<th>${i+1}</th>`).join("")}
                <th>18</th><th>19</th><th>20</th><th>21</th><th>22</th><th>23</th>
            </tr>
        </thead>
        <tbody>
            ${values.part1.rowsA.map(r => {
                const sub = (r.creditValues || []).reduce((a, b) => a + num(b), 0);
                const ot = (r.otherVoucherValues || []).reduce((a, b) => a + num(b), 0);
                return `<tr>
                    <td align="center">${r.index}</td>
                    <td>${r.debitAccountCode}</td>
                    ${r.creditValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                    <td align="right" class="font-bold">${fmt(sub)}</td>
                    ${r.otherVoucherValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                    <td align="right" class="font-bold">${fmt(sub + ot)}</td>
                </tr>`;
            }).join("")}
            <tr class="font-bold bg-grey">
                <td align="center">13</td><td>Cộng A</td>
                ${tA.creditValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right">${fmt(tA.subTotalCredit)}</td>
                ${tA.otherVoucherValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right">${fmt(tA.totalCost)}</td>
            </tr>
            ${values.part1.rowsB.map(r => {
                const sub = (r.creditValues || []).reduce((a, b) => a + num(b), 0);
                const ot = (r.otherVoucherValues || []).reduce((a, b) => a + num(b), 0);
                return `<tr>
                    <td align="center">${r.index}</td>
                    <td>${r.debitAccountCode}</td>
                    ${r.creditValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                    <td align="right" class="font-bold">${fmt(sub)}</td>
                    ${r.otherVoucherValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                    <td align="right" class="font-bold">${fmt(sub + ot)}</td>
                </tr>`;
            }).join("")}
            <tr class="font-bold bg-grey">
                <td align="center">24</td><td>Cộng B</td>
                ${tB.creditValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right">${fmt(tB.subTotalCredit)}</td>
                ${tB.otherVoucherValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right">${fmt(tB.totalCost)}</td>
            </tr>
            <tr class="font-bold bg-dark text-white">
                <td align="center">25</td><td>Tổng cộng (A+B)</td>
                ${tAB.creditValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right">${fmt(tAB.subTotalCredit)}</td>
                ${tAB.otherVoucherValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right">${fmt(tAB.totalCost)}</td>
            </tr>
        </tbody>
    </table>
    <div class="page-break"></div>
  `;

  const part2Html = `
    <div class="section-subtitle">Phần II: CHI PHÍ SẢN XUẤT, KINH DOANH THEO YẾU TỐ</div>
    <div style="text-align: center; font-weight: bold; margin-bottom: 10px;">Tháng ${values.month} năm ${values.year}</div>
    <table class="print-table" style="width: 100%;">
        <thead>
            <tr>
                <th width="40" rowspan="2">Số TT</th>
                <th rowspan="2">Tên các tài khoản chi phí</th>
                <th colspan="5">Yếu tố chi phí sản xuất, kinh doanh</th>
                <th rowspan="2" width="80">Cộng</th>
                <th rowspan="2" width="100">Luân chuyển</th>
                <th rowspan="2" width="100">Tổng cộng</th>
            </tr>
            <tr>
                <th>Nguyên liệu</th><th>Nhân công</th><th>Khấu hao</th><th>Dịch vụ</th><th>Khác</th>
            </tr>
            <tr class="bg-light-grey">
                <th>A</th><th>B</th><th>1</th><th>2</th><th>3</th><th>4</th><th>5</th><th>6</th><th>7</th><th>8</th>
            </tr>
        </thead>
        <tbody>
            ${values.part2.rows.map(r => {
                const sub = (r.elementValues || []).reduce((a, b) => a + num(b), 0);
                return `<tr>
                    <td align="center">${r.index}</td>
                    <td>${r.accountName}</td>
                    ${r.elementValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                    <td align="right">${fmt(sub)}</td>
                    <td align="right">${fmt(r.internalTurnover)}</td>
                    <td align="right" class="font-bold">${fmt(sub - num(r.internalTurnover))}</td>
                </tr>`;
            }).join("")}
            <tr class="font-bold bg-grey">
                <td align="center">12</td><td>Cộng trong tháng</td>
                ${values.part2.totals.elementValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right">${fmt(values.part2.totals.subTotal)}</td>
                <td align="right">${fmt(values.part2.totals.internalTurnover)}</td>
                <td align="right">${fmt(values.part2.totals.totalCost)}</td>
            </tr>
             <tr class="font-bold">
                <td align="center">13</td><td>Luỹ kế đầu năm</td>
                ${values.part2.totals.accumulatedValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right">${fmt(values.part2.totals.accumulatedSubTotal)}</td>
                <td align="right">${fmt(values.part2.totals.accumulatedInternalTurnover)}</td>
                <td align="right">${fmt(values.part2.totals.accumulatedTotalCost)}</td>
            </tr>
        </tbody>
    </table>
    <div class="page-break"></div>
  `;

  const part3Html = `
    <div class="section-subtitle">Phần III: SỐ LIỆU CHI TIẾT PHẦN "LUÂN CHUYỂN NỘI BỘ..."</div>
    <div style="text-align: center; font-weight: bold; margin-bottom: 10px;">Tháng ${values.month} năm ${values.year}</div>
    <table class="print-table" style="width: 100%;">
        <thead>
            <tr>
                <th width="40" rowspan="2">Số TT</th>
                <th rowspan="2">Tên tài khoản</th>
                <th colspan="9">Số liệu chi tiết</th>
                <th rowspan="2" width="80">Cộng</th>
            </tr>
            <tr>
                ${values.part3.columnLabels.map(l => `<th style="font-size: 7px;">${l || ""}</th>`).join("")}
            </tr>
            <tr class="bg-light-grey">
                <th>A</th><th>B</th>${Array.from({ length: 9 }).map((_, i) => `<th>${i+1}</th>`).join("")}<th>10</th>
            </tr>
        </thead>
        <tbody>
            ${values.part3.rows.map(r => `<tr>
                <td align="center">${r.index}</td>
                <td>${r.accountName}</td>
                ${r.detailValues.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right" class="font-bold">${fmt(r.total)}</td>
            </tr>`).join("")}
            <tr class="font-bold bg-grey">
                <td colspan="2" align="center">Cộng</td>
                ${values.part3.columnTotals.map(v => `<td align="right">${fmt(v)}</td>`).join("")}
                <td align="right">${fmt(values.part3.grandTotal)}</td>
            </tr>
        </tbody>
    </table>
  `;

  return `
    <div class="print-container">
      <div style="display: flex; justify-content: space-between;">
        <div class="font-bold">Đơn vị: ${values.unit}<br/>Địa chỉ: ${values.address}</div>
        <div class="font-bold text-right">Mẫu số S04a7-DN<br/><span style="font-weight: normal; font-size: 8px;">(Kèm theo Thông tư số 99/2025/TT-BTC)</span></div>
      </div>

      ${part1Html}
      ${part2Html}
      ${part3Html}

      <div style="margin-top: 20px; display: grid; grid-template-columns: 1fr 1fr 1fr; text-align: center; font-size: 10px;">
        <div>
            <b>Đã ghi sổ Cái ngày...</b><br/><b>Người ghi sổ</b><br/><i>(Ký, họ tên)</i><br/><br/><br/><b>${values.ledgerClerk || ""}</b>
        </div>
        <div>
            <br/><b>Kế toán trưởng</b><br/><i>(Ký, họ tên)</i><br/><br/><br/><b>${values.chiefAccountant || ""}</b>
        </div>
        <div>
            <i>Ngày ${values.signingDay} tháng ${values.signingMonth} năm ${values.signingYear}</i><br/>
            <b>Người đại diện pháp luật</b><br/><i>(Ký, họ tên, đóng dấu)</i><br/><br/><br/><b>${values.legalRepresentative || ""}</b>
        </div>
      </div>

      <style>
        .print-container { font-family: "Times New Roman", Times, serif; font-size: 9px; padding: 5px; color: black; }
        .print-table { border-collapse: collapse; margin-top: 5px; font-size: 8px; width: 100%; table-layout: fixed; }
        .print-table th, .print-table td { border: 1px solid black; padding: 2px; overflow: hidden; word-wrap: break-word; }
        .print-table th { background-color: #f2f2f2; text-transform: uppercase; }
        .diagonal-header { background: linear-gradient(to top right, transparent 49.5%, #000 49.5%, #000 50.5%, transparent 50.5%); }
        .section-title { font-size: 13px; font-weight: bold; text-align: center; text-transform: uppercase; }
        .section-subtitle { font-size: 11px; font-weight: bold; text-align: center; margin-top: 10px; text-transform: uppercase; }
        .bg-grey { background-color: #eee; }
        .bg-light-grey { background-color: #f9f9f9; }
        .bg-dark { background-color: #333; }
        .text-white { color: white; }
        .font-bold { font-weight: bold; }
        .page-break { page-break-after: always; }
        @media print { @page { size: landscape; margin: 0.5cm; } }
      </style>
    </div>
  `;
};
